import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { initDatadog } from './core/services/telemetry/datadog';
import { registerChunkReloadRecovery } from './core/utils/chunkReloadRecovery';

// Initialize Datadog Browser RUM + Logs as early as possible so that
// initial page load, resources and errors are captured.
initDatadog();

// Self-heal a stale-chunk-after-deploy dynamic-import failure (858075) before it can
// ever reach the root TelemetryErrorBoundary as a generic error screen.
registerChunkReloadRecovery();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
